import { FASTIFY_BASE_URL } from '../config/apiConfig';
import { api } from './api';

/**
 * Move every row of an import to a new business date in one transaction.
 * body: { effectiveDate } | { shiftDays }, plus optional fromDate,
 * updateFileRecord (default true), refreshDashboard (default true), note.
 */
export const moveImportBusinessDate = async (importId, body) => {
  const response = await api.post(`${FASTIFY_BASE_URL}/imports/${importId}/businessDate`, body);
  return response.data;
};

/** After a correction: refresh the dashboard for `dates` and log the reason. */
export const refreshImportDashboard = async (importId, { dates, note } = {}) => {
  const response = await api.post(`${FASTIFY_BASE_URL}/imports/${importId}/refreshDashboard`, { dates, note });
  return response.data;
};
